






























































































































































import { Currency } from "@/shared/models/currency";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

export interface ReservationFinancesSummaryViewModel {
  currencyCode: string;

  accommodationTotalPrice: number;
  accommodationTotalInputPrice?: number;
  accommodationTotalMargin?: number;
  accommodationTotalMarginPercent?: number;

  addOnServicesTotalPrice: number;
  addOnServicesTotalInputPrice?: number;
  addOnServicesTotalMargin?: number;
  addOnServicesTotalMarginPercent?: number;

  totalPrice: number;
  totalInputPrice?: number;
  totalMargin?: number;
  totalMarginPercent?: number;
}

@Component
export default class FinancialDocumentReservationSummary extends Vue {
  @Prop() reservationId?: number;

  @Getter("appParams/workingCurrency") workingCurrency?: Currency;
  @Getter("appParams/tenantUsesInputPrice") tenantUsesInputPrice?: boolean;

  isExpanded = false;
  reservationSummary = null as ReservationFinancesSummaryViewModel | null;

  get isReservationFound() {
    return this.reservationId && this.reservationSummary;
  }

  getPercentage(value: number) {
    return (
      this.$n(value * 100, {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }) + "%"
    );
  }

  mounted() {
    if (this.reservationId) {
      this.axios
        .get<ReservationFinancesSummaryViewModel>(
          `FinancialDocuments/GetReservationFinancesSummary/${this.reservationId}`
        )
        .then((res) => {
          this.reservationSummary = res.data ?? null;
        });
    }
  }
}
